export type DisabledAppearance = "faded" | "solid";

export interface ButtonState {
  /** The native `disabled` attribute: a loading button cannot be pressed. */
  isDisabled: boolean;
  /** `aria-busy` is present only while loading. */
  ariaBusy: true | undefined;
  /** Cursor and opacity. A loading button stays fully painted — it is
   * working, not unavailable — even when it is also disabled. */
  interactionClass: string;
}

export function resolveButtonState({
  disabled,
  isLoading,
  disabledAppearance,
}: {
  disabled: boolean;
  isLoading: boolean;
  disabledAppearance: DisabledAppearance;
}): ButtonState {
  const interactionClass = interactionClassFor({
    disabled,
    isLoading,
    disabledAppearance,
  });
  return {
    isDisabled: disabled || isLoading,
    ariaBusy: isLoading ? true : undefined,
    interactionClass,
  };
}

function interactionClassFor({
  disabled,
  isLoading,
  disabledAppearance,
}: {
  disabled: boolean;
  isLoading: boolean;
  disabledAppearance: DisabledAppearance;
}): string {
  if (isLoading) return "cursor-default";
  if (!disabled) return "cursor-pointer";
  if (disabledAppearance === "solid") return "cursor-default";
  return "opacity-50 cursor-not-allowed";
}
